import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
interface NavbarProps {
  handlePurchase: () => void;
}
export function Navbar({
  handlePurchase
}: NavbarProps) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  return <>
      <nav className="sticky top-0 z-[9999] bg-dark/90 backdrop-blur-md border-b border-gold/15 h-[70px] flex items-center justify-between px-[5%]" data-id="element-104">
        <div className="font-serif italic text-gold text-xl font-bold tracking-[2px]" data-id="element-105">
          EL CÓDIGO 888
        </div>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center" data-id="element-106">
          <a href="#la-frecuencia" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-gold mr-5" data-id="element-107">
            La Frecuencia
          </a>
          <a href="#la-ciencia" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-gold mr-5" data-id="element-108">
            La Ciencia
          </a>
          <a href="#testimonios" className="text-gold text-[11px] font-extrabold uppercase border-b-2 border-gold pb-[2px] mr-5" data-id="element-109">
            Resultados
          </a>
          <a href="#protocolo" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-gold mr-5" data-id="element-110">
            El Manual
          </a>
          <button onClick={handlePurchase} className="bg-gold text-dark text-[11px] font-extrabold px-6 py-2.5 rounded shadow-[0_4px_15px_rgba(212,175,55,0.3)] hover:scale-105 transition-transform uppercase tracking-wide" data-id="element-111">
            Activar Ahora
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button className="lg:hidden text-gold" onClick={toggleMenu} data-id="element-112">
          {isOpen ? <X size={28} data-id="element-113" /> : <Menu size={28} data-id="element-114" />}
        </button>
      </nav>

      {/* Mobile Overlay */}
      {isOpen && <div className="fixed inset-0 top-[70px] bg-dark/95 backdrop-blur-xl z-[9998] flex flex-col items-center pt-12 space-y-8 lg:hidden" data-id="element-115">
          <a href="#la-frecuencia" onClick={toggleMenu} className="text-white text-sm font-bold uppercase tracking-[2px]" data-id="element-116">
            La Frecuencia
          </a>
          <a href="#la-ciencia" onClick={toggleMenu} className="text-white text-sm font-bold uppercase tracking-[2px]" data-id="element-117">
            La Ciencia
          </a>
          <a href="#testimonios" onClick={toggleMenu} className="text-gold text-sm font-extrabold uppercase tracking-[2px]" data-id="element-118">
            Resultados
          </a>
          <a href="#protocolo" onClick={toggleMenu} className="text-white text-sm font-bold uppercase tracking-[2px]" data-id="element-119">
            El Manual
          </a>
          <button onClick={() => {
        toggleMenu();
        handlePurchase();
      }} className="mt-4 bg-gold text-dark text-sm font-extrabold px-8 py-3 rounded shadow-[0_4px_15px_rgba(212,175,55,0.3)] uppercase tracking-wide" data-id="element-120">
            Acceso Inmediato
          </button>
        </div>}
    </>;
}